import { getAccountInformation } from '@va/dashboard/selectors/api';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { ReportBlockConfigProvider } from '@va/ui/components/report-block';
import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

export const DashboardReportBlockConfigProvider = ({ children }: PropsWithChildren<{}>) => {
  const websiteId = useSelector(getInstanceId);
  const userId = useSelector(getAccountInformation).id ?? '';

  return <ReportBlockConfigProvider storageNamespace={`${userId}-${websiteId}`}>{children}</ReportBlockConfigProvider>;
};
